var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_import",
    "data-name": "Icon - import",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1,.cls-2{fill:none}.cls-2{stroke:currentColor}.cls-3{stroke:none}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1683",
    className: "cls-1",
    d: "M0 0h20v20H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8252",
    transform: "translate(3.247 3.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_864",
    className: "cls-2",
    transform: "rotate(135 6.56 3.175)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 17.907,
    height: 1.105,
    rx: 0.553
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.5,
    width: 16.907,
    height: 0.105,
    rx: 0.053
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_865",
    className: "cls-2",
    transform: "rotate(45 .422 1.019)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 17.907,
    height: 1.105,
    rx: 0.553
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.5,
    width: 16.907,
    height: 0.105,
    rx: 0.053
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.3541aad746d447d39549689ea65a68f5.svg";
export { ForwardRef as ReactComponent };